import { motion } from "framer-motion";
import {
  Waves,
  Sailboat,
  LifeBuoy,
  Flame,
  TreePalm,
  Baby,
  Gamepad2,
  Car,
} from "lucide-react";
import { AMENITIES } from "@/data/content";

const ICONS = {
  Waves,
  Sailboat,
  LifeBuoy,
  Flame,
  TreePalm,
  Baby,
  Gamepad2,
  Car,
};

export const Amenities = () => {
  return (
    <section
      id="atrakcje"
      data-testid="amenities-section"
      className="bg-[#F9F7F3] py-20 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#4A7055]">
            Wszystko w cenie
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-[#2D3728] text-balance md:text-4xl lg:text-5xl">
            Atrakcje i udogodnienia na wyłączność
          </h2>
          <p className="mt-4 text-base leading-relaxed text-[#4A5D43] md:text-lg">
            Cały teren i sprzęt są do dyspozycji wyłącznie naszych Gości — bez
            dzielenia się z innymi.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {AMENITIES.map((a, i) => {
            const Icon = ICONS[a.icon];
            return (
              <motion.div
                key={a.name}
                data-testid={`amenity-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                className="group overflow-hidden rounded-2xl border border-[#E4DDCF] bg-white transition-all duration-300 hover:-translate-y-1.5 hover:border-[#4A7055]/40 hover:shadow-xl hover:shadow-[#4A7055]/10"
              >
                <div className="relative h-36 w-full overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.name}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
                  <div className="absolute bottom-3 left-3 flex h-9 w-9 items-center justify-center rounded-lg bg-white/90 text-[#4A7055] backdrop-blur-sm">
                    {Icon && <Icon className="h-5 w-5" />}
                  </div>
                </div>
                <div className="p-6 pt-5">
                  <h3 className="font-display text-lg font-semibold text-[#2D3728]">
                    {a.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#6b7563]">
                    {a.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
